export const DECIDED_LIST_LABELS = {
    title: 'Já respondidas por você',
    subtitle: 'Solicitações que saíram da sua fila. Ficam aqui como registro da decisão.',
    count: (total: number) =>
        total === 1 ? '1 solicitação respondida' : `${total} solicitações respondidas`,
    noteLabel: 'Justificativa',
    decidedAt: 'Decidida em',
    showMore: (remaining: number) =>
        `Ver mais ${remaining === 1 ? '1 solicitação' : `${Math.min(remaining, 5)} solicitações`}`,
    showLess: 'Ver menos',
    shown: (shown: number, total: number) => `Mostrando ${shown} de ${total}`,
} as const;

export const DECIDED_BATCH_SIZE = 5;
